import { ALL_COUNTRIES, DEFAULT_COUNTRY } from './constants/countries';
import { ATTEMPT_TYPES, MAX_NUM_OF_ATTEMPTS } from './constants/attempts';
import {
  IBAN_LENGTH,
  BANK_LIST,
  IBAN_PLACEHOLDER
} from './constants/bank-details';
import { PHONE_NUMBER_MAX_LENGTH } from './constants/validations';
import { IMAGES_LIST } from './constants/sllr-empty-state';
import {
  CURRENCY,
  FAWRY_AVAILABILITIY,
  PAYMOB_AVAILABILITY,
  BOSTA_CAPITAL_AVAILABILITY,
  SLLR_PAY_AVAILABLITITY,
  CIRCLE_K_AVAILABLITITY,
  CAN_BUY_EXTRA_FLYERS,
  MOYASAR_AVAILABILITY,
  BANK_RECHARGE_AVAILABILITY,
  SHOW_INTERNATIONAL_BANKS
} from './constants/finance';
import {
  AWB_LANGUAGE,
  DEFAULT,
  ORDERS_SEARCH_PHONE_NUMBER_REGEX,
  PHONE_NUMBER_REGEX,
  WITHOUT_COUNTRY_CODE,
  ENGLISH_LETTERS_RULE_APPLICABLE,
  PICKUP_SCHEDULE_TIME_FOR_SAME_DAY,
  COUNTRY_PHONE_PLACEHOLDER,
  CITY_AREA_PLACEHOLDER_ID,
  IS_SHOP_AVAILABLE,
  NATIONAL_ID_COUNT
} from './constants/common';
import { IS_SMART_STICKERS_AVAILABLE } from './constants/orders';
import { SHOW_INSTANT_CASHOUT_PLAN } from './constants/pricing';
import { VAT_AVAILABILTY } from './constants/signup';
import { OPEN_PACKAGE_FEES_AVAILABILTY } from 'constants/common';

const countryCode = JSON.parse(localStorage.getItem('userInfo'))?.user?.country
  ?.code;

const currentUserCountry =
  ALL_COUNTRIES.find(({ codeName }) => countryCode === codeName) ||
  DEFAULT_COUNTRY;

export const currentUserCountryCode = currentUserCountry.codeName;

const retryToGetUserCountryCode = () => {
  const fetchCountryCodeAgain = JSON.parse(localStorage.getItem('userInfo'))
    ?.user?.country?.code;
  const currentUserCountry =
    ALL_COUNTRIES.find(({ codeName }) => fetchCountryCodeAgain === codeName) ||
    DEFAULT_COUNTRY;
  return currentUserCountry.codeName;
};

export const getCurrentUserCountryData = () => {
  return currentUserCountry;
};

/* Attempts */
export const getAttemptsTypes = () => {
  return ATTEMPT_TYPES;
};

export const getMaxNumOfAttempts = () => {
  const { DELIVERY, PICKUP, RETURN } =
    MAX_NUM_OF_ATTEMPTS[currentUserCountryCode] || MAX_NUM_OF_ATTEMPTS.DEFAULT;

  return {
    DELIVERY,
    PICKUP,
    RETURN
  };
};

export const isMaxNumOfAttempts = (numOfAttempts) => {
  const { DELIVERY, PICKUP, RETURN } = getMaxNumOfAttempts();

  return {
    DELIVERY: (numOfAttempts = DELIVERY),
    PICKUP: (numOfAttempts = PICKUP),
    RETURN: (numOfAttempts = RETURN)
  };
};

/* common */
export const getAWBLanguage = () => {
  return AWB_LANGUAGE[currentUserCountryCode] || AWB_LANGUAGE.DEFAULT;
};

export const getPhoneNumberMaxLength = () => {
  return PHONE_NUMBER_MAX_LENGTH[currentUserCountryCode];
};

export const getCurrency = (cod) => {
  return CURRENCY(cod)[currentUserCountryCode];
};

export const getPhoneNumberRegexForDigits = (numOfDigits) => {
  const countries = {
    EG: `^(\\+20|0)1([0-2]|5)[0-9]{2,}`,
    SA: `^(\\+966|0)?[0-9]{4,}`
  };

  return new RegExp(countries[currentUserCountryCode]);
};

export const getPhoneNumberRegex = ({
  countryCode = currentUserCountryCode,
  withoutCountryCode
}) => {
  return PHONE_NUMBER_REGEX[countryCode][
    withoutCountryCode ? WITHOUT_COUNTRY_CODE : DEFAULT
  ];
};

export const ordersPhoneNumberSearchRegex =
  ORDERS_SEARCH_PHONE_NUMBER_REGEX[currentUserCountryCode] ||
  ORDERS_SEARCH_PHONE_NUMBER_REGEX.DEFAULT;

export const getPickupScheduleTimeForSameDay = () =>
  PICKUP_SCHEDULE_TIME_FOR_SAME_DAY[currentUserCountryCode] ||
  PICKUP_SCHEDULE_TIME_FOR_SAME_DAY.DEFAULT;

export const getPhonePlaceholder = () => {
  return COUNTRY_PHONE_PLACEHOLDER[currentUserCountryCode];
};

export const getCityAreaPlaceholder = () => {
  return CITY_AREA_PLACEHOLDER_ID[currentUserCountryCode];
};

/* Bank Details */
export const getIBANLength = () => {
  return IBAN_LENGTH[currentUserCountryCode];
};

export const getBankList = () => {
  return BANK_LIST[currentUserCountryCode];
};

export const getIBANPlaceholder = () => {
  return IBAN_PLACEHOLDER[currentUserCountryCode];
};

// Currency
export const getUserCurrency = (cod) => {
  if (cod !== undefined) {
    return CURRENCY(cod)[currentUserCountryCode];
  }
  return CURRENCY()[currentUserCountryCode].type;
};

export const isFawryAvailable = () => {
  return FAWRY_AVAILABILITIY[currentUserCountryCode];
};

export const isEnglishLettersRuleApplicable = () => {
  return ENGLISH_LETTERS_RULE_APPLICABLE[currentUserCountryCode];
};

export const isPayMobAvailable = () => {
  return PAYMOB_AVAILABILITY[currentUserCountryCode];
};

export const isMoyasarAvailable = () => {
  return MOYASAR_AVAILABILITY[currentUserCountryCode];
};

export const isBankRechargeAvailable = () => {
  return BANK_RECHARGE_AVAILABILITY[currentUserCountryCode];
};

/* sllr empty state */
export const getEmptyStateImage = (image) => {
  return IMAGES_LIST[currentUserCountryCode][image];
};

export const isUserAllowedToShowAccountLockedModal = () => {
  const allowCheckForNegativeBalance = JSON.parse(
    localStorage.getItem('userInfo')
  )?.user?.country?.allowCheckForNegativeBalance;
  return allowCheckForNegativeBalance !== undefined &&
    allowCheckForNegativeBalance !== null
    ? allowCheckForNegativeBalance
    : true;
};

export const isBostaCapitalAvailable = () => {
  return (
    BOSTA_CAPITAL_AVAILABILITY[currentUserCountryCode] &&
    !window?.location?.host?.includes('dashboard.sllr')
  );
};

export const isBostaShopAvailable = () => {
  return IS_SHOP_AVAILABLE[currentUserCountryCode];
};

export const isSmartStickersAvailable = () => {
  return IS_SMART_STICKERS_AVAILABLE[currentUserCountryCode];
};

export const isSllrPayAvailable = () => {
  return SLLR_PAY_AVAILABLITITY[currentUserCountryCode];
};

export const isCircleKAvailable = () => {
  return CIRCLE_K_AVAILABLITITY[currentUserCountryCode];
};

export const canBuyExtraFlyersThanTheLimit = () => {
  return CAN_BUY_EXTRA_FLYERS[currentUserCountryCode];
};

export const isInstantCashoutPlanAvailable = () => {
  if (countryCode) {
    return SHOW_INSTANT_CASHOUT_PLAN[currentUserCountryCode];
  } else {
    return SHOW_INSTANT_CASHOUT_PLAN[retryToGetUserCountryCode()];
  }
};

export const isVatAvailable = () => {
  return VAT_AVAILABILTY[currentUserCountryCode];
};

export const handleInternationalBanks = () => {
  return SHOW_INTERNATIONAL_BANKS[currentUserCountryCode];
};

export const getNationalIdMaxCount = () => {
  return NATIONAL_ID_COUNT[currentUserCountryCode];
};

export const isOpenPackageFeesAvailable = () => {
  return OPEN_PACKAGE_FEES_AVAILABILTY[currentUserCountryCode];
};
